import React, { useRef } from 'react'
import { useToggle, useOnClickOutside, useIntl } from 'hooks'
import { IconClose } from 'components/Zui/Icon'
import Modal from 'components/Modals/ContextModal'

export const useContextModal = (Component, options) => {
    const { t } = useIntl()
    const contextRef = useRef(null)
    const { isOpen, onOpen, onClose, onToggle } = useToggle()
    const { refId, headerText, ...props } = options

    useOnClickOutside(contextRef, onClose, refId)

    const ContextModal = () => {
        return (
            isOpen && (
                <Modal ref={contextRef}>
                    <div className="context-modal-header">
                        <div className="context-modal-heading">
                            <span>{t(headerText)}</span>
                        </div>
                        <div className="context-modal-close-button" onClick={onClose}>
                            <IconClose size="m" />
                        </div>
                    </div>
                    {Component && <Component {...props} />}
                </Modal>
            )
        )
    }

    return { ContextModal, isOpen, onOpen, onClose, onToggle }
}
